_collow.components.HomePageCarousel = class HomePageCarousel extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  ammountCards;
  cardFitting;
  allowedCourses;
  originalCourses;
  courseGroups;
  userIsLogged;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.ammountCards = elements.position.childNodes.length;
    this.originalCourses = [...this.elements.position.childNodes];
    this.cardFit(window.innerWidth);
    this.listen(elements.prevbtn, "click", this.btnClick.bind(null, -1));
    this.listen(elements.nextbtn, "click", this.btnClick.bind(null, 1));
    this.listen(window, "resize", this.resizing);

    if (this.ammountCards <= this.cardFitting) this.hideNext();

    this.userIsLogged = window.localStorage.getItem('token')

    this.initCoursesList();
  }

  /** Fetches allowed courses for current user and populates the list. */
  initCoursesList = async () => {
    let excludedProjects = ["Collow"];
    if (!excludedProjects.includes(this.params.project)) return

    let accesibleFeatures = JSON.parse(window.localStorage.getItem('whitelabelFeatures') || '{}');
    let hasUserGroups = accesibleFeatures?.has_user_groups ? accesibleFeatures.has_user_groups : false;

    try {
      // Use the Courses class's shared cache if available
      if (window.localStorage.getItem('token') && hasUserGroups) {
        await this.fetchAllowedCourses();
      }
      
      await this.fetchAllCourses();
      this.addCoursesToBody();
    } catch (error) {
      console.error('Error initializing courses list:', error);
    }
  }

  /** Filters the list of courses based on whether the user is logged in and whether the course is private. If the user is logged in, it 
   * checks if the user has access to private courses. If the user is not logged in, only public courses are returned. */
  hidePrivateCourses = (courses) => {
    if (!courses || !Array.isArray(courses)) return [];
    
    let accessibleCourses = []
    if(this.userIsLogged) {
      courses.forEach(course => {
        if(!course || !course.dataset) return;
        
        if(course.dataset.private === "true") {
          if(!Array.isArray(this.allowedCourses)) return;
          
          const isAllowedCourse = this.allowedCourses.includes(course.dataset.link)
          if(isAllowedCourse) accessibleCourses.push(course) 
        } else {
          accessibleCourses.push(course)
        }
      })
    } else {
      accessibleCourses = courses.filter(course => course && course.dataset && course.dataset.private === "false")
    }
    
    return accessibleCourses
  }

  addCourseDataGroupAttr = (courses) => {
    if (!courses || !Array.isArray(courses)) return [];
    
    courses.forEach(course => {
      if (!course || !course.dataset) return;
      
      let courseName;
      let courseGroups;

      if (course.className && course.className.includes("brainsfirst-card")) {
        courseName = "brainsfirst-card";
        courseGroups = "brainsfirst-card";
      } else {
        courseName = course.dataset.link;
        if (!courseName) {
          courseGroups = "";
        } else if (Array.isArray(this.courseGroups)) {
          courseGroups = this.courseGroups.find(el => el && el.courseName === courseName)?.groups || "";
        } else {
          courseGroups = "";
        }
      }
      course.dataset.groups = courseGroups;
    });
    return courses;
  }

  /** Adds a 'usersReg' attribute to each course element based on the course's usersReg data.*/
  addCourseDataUsersRegisteredAttr = (courses) => {
    if (!courses || !Array.isArray(courses)) return [];
    
    courses.forEach(course => {
      if (!course || !course.dataset) return;
      
      const courseName = course.dataset.link;
      if (!courseName) {
        course.dataset.usersReg = "0";
        return;
      }
      
      let usersRegistered = "0";
      if (Array.isArray(this.courseGroups)) {
        usersRegistered = this.courseGroups.find(el => el && el.courseName === courseName)?.registeredUsers || "0";
      }
      
      course.dataset.usersReg = usersRegistered;
    });
    return courses;
  }

  /** Updates the course element with the number of registered users. */
  addRegisteredUsersInfo = (course) => {
    if (!course || !course.dataset || !course.getAttribute('data-participantsCount')) return course;
    
    let excludedProjects = ["Collow"];
    const isCollow = excludedProjects.includes(this.params.project)

    if(course.dataset.usersReg != 0 && course.dataset.usersReg >=3 && isCollow) {
      const participantsCount = course.getAttribute('data-participantsCount').replaceAll("_", " ");
      const regUsersParagraph = course.querySelector(".users-registered")
      if (regUsersParagraph) {
        regUsersParagraph.textContent = `${course.dataset.usersReg}+ ${participantsCount}`;
      }
    }    
    return course
  }

  sortCoursesByPaymentStatus = (courses) => {
    if (!courses || !Array.isArray(courses)) return [];
    
    // Apply data attributes to courses
    let coursesWithGroups = this.addCourseDataGroupAttr(courses);
    let coursesWithUsersRegistered = this.addCourseDataUsersRegisteredAttr(coursesWithGroups);
    
    // Skip processing if no courses or no data
    if (!coursesWithUsersRegistered || !coursesWithUsersRegistered.length) return [];
    
    const userIsLogged = Array.isArray(this.allowedCourses) && this.allowedCourses.length > 0;
    const brainsfirstGroup = "brainsfirst-card";
    const freeCourseCod = 116;
    
    // Safely get all course names, filtering out undefined values
    const allCoursesNames = coursesWithUsersRegistered
      .filter(el => el && el.dataset && el.dataset.link)
      .map(el => el.dataset.link);
    
    // Get unpurchased course names if user is logged in
    const allUnpurchasedCoursesNames = userIsLogged && this.allowedCourses 
      ? allCoursesNames.filter(el => !this.allowedCourses.includes(el))
      : [];
    
    // Filter courses based on criteria
    // Safe filter for allowed courses
    const allowedCourses = userIsLogged && this.allowedCourses 
      ? coursesWithUsersRegistered.filter(el => 
          el && el.dataset && el.dataset.link && this.allowedCourses.includes(el.dataset.link)
        ) 
      : [];
    
    // Safe filter for brainsfirst cards
    let brainsfirstCard = coursesWithUsersRegistered.filter(el => 
      el && el.dataset && el.dataset.groups && el.dataset.groups.includes(brainsfirstGroup)
    );
    
    // Safe filter for free courses
    let freeCourses = coursesWithUsersRegistered.filter(el => 
      el && el.dataset && el.dataset.groups && el.dataset.groups.includes(freeCourseCod)
    );
    
    // Filter purchased courses that aren't free
    let purchasedCourses = allowedCourses.length 
      ? allowedCourses.filter(el => 
          el && el.dataset && el.dataset.groups && !el.dataset.groups.includes(freeCourseCod)
        ) 
      : [];
    
    // Get unpurchased courses based on login status
    let unpurchasedCourses = [];
    if (userIsLogged) {
      // For logged-in users, find courses they haven't purchased that aren't brainsfirst
      unpurchasedCourses = allUnpurchasedCoursesNames
        .map(name => coursesWithUsersRegistered.filter(el =>
          el && el.dataset && el.dataset.link === name && 
          el.dataset.groups && !el.dataset.groups.includes(brainsfirstGroup)
        ))
        .flat();
    } else {
      // For guests, find courses that aren't free and aren't brainsfirst
      unpurchasedCourses = coursesWithUsersRegistered.filter(el =>
        el && el.dataset && el.dataset.groups && 
        !el.dataset.groups.includes(freeCourseCod) && 
        !el.dataset.groups.includes(brainsfirstGroup)
      );
    }
    
    // Combine all categories and filter out any falsy values
    let allCourses = [...brainsfirstCard, ...freeCourses, ...purchasedCourses, ...unpurchasedCourses]
      .filter(Boolean);
      
    return allCourses;
  }

  /** Populates the list with either courses or with a message, in case no courses are available. */
  addCoursesToBody = (courses = this.originalCourses) => {
    let excludedProjects = ["Collow"];
    this.elements.position.innerHTML = "";
    
    const brainsfirtsCard = courses.find(course => course?.className?.includes("brainsfirst-card"))

    if (courses?.length) {
      const isCollow = excludedProjects.includes(this.params.project)
      let coursesToRender = brainsfirtsCard ? [brainsfirtsCard] : []

      if(isCollow) {
        const newCourses = this.hidePrivateCourses(courses)
        coursesToRender = [...coursesToRender, ...this.sortCoursesByPaymentStatus(newCourses)]
      } else {
        coursesToRender = [...coursesToRender, ...courses]
      }
      
      coursesToRender = coursesToRender.filter(Boolean);
      
      coursesToRender.forEach((course) => {
        if (!course) return;
        let newCourse = this.addRegisteredUsersInfo(course)
        this.elements.position.appendChild(newCourse)
      });
    }
  }

  btnClick = (num) => {
    const sign = Math.sign(num || 0) || 0;
    if (sign !== 0) {
      const count = Math.max(0, this.elements.position.scrollLeft / 240 + sign * this.cardFitting);
      this.elements.position.scrollLeft = Math.floor(count) * 240;
    }
    if (this.elements.position.scrollLeft < 240) this.hidePrev();
    else this.showPrev();
    if (this.elements.position.scrollLeft + this.cardFitting * 240 > this.ammountCards * 240 - 240) this.hideNext();
    else this.showNext();
  };

  showNext = () => {
    this.elements.nextbtn.classList.remove("hidden");
  };
  hideNext = () => {
    this.elements.nextbtn.classList.add("hidden");
  };
  showPrev = () => {
    this.elements.prevbtn.classList.remove("hidden");
  };
  hidePrev = () => {
    this.elements.prevbtn.classList.add("hidden");
  };

  cardFit = (width) => {
    let cardWidth = 240;
    let screenWidth = width - 160;
    const fitCount = Math.floor(screenWidth / cardWidth);
    this.cardFitting = fitCount;
    this.btnClick();
  };

  resizing = (e) => {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(() => {
      this.cardFit(e.target.innerWidth);
    }, 250);
  };

  /**  check if course is being followed and change button accordingly */
  setFollowedCourses = () => {
    const courses = localStorage.getCourses();
    if (!courses || !courses.length) return;

    this.elements.position.childNodes.forEach((el) => {
      if (!el || !el.dataset) return;
      const link = el.dataset.link;
      if (!link) return;
      
      const nextlink = courses.filter((item) => {
        return item && item.course && item.course["unique_identifer"] == link;
      })?.[0];

      if (nextlink) {
        const button = el.querySelector("[data-card-button]");
        if (button && button.dataset) {
          button.textContent = button.dataset.continueText;
        }
      }
    });
  };

  disablePaidCoursesForGuestUsers = (freeCourses) => {
    if (!Array.isArray(freeCourses)) return;
    
    this.elements.position.childNodes.forEach((el) => {
      if (!el || !el.dataset) return;
      const link = el.dataset.link;
      if (!link) return;
      
      const isFreeCourse = freeCourses.includes(link);

      if (!isFreeCourse) {
        el.classList.add("grey-status");
        const button = el.querySelector("[data-card-button]");
        if (button && button.dataset) {
          button.textContent = button.dataset.checkoutText;
        }
      } else if (el.className && el.className.includes("brainsfirst-card")) {
        // Handle brainsfirst-card case if needed
      }
    });
  }

  setGreyCourses = () => {
    const courses = localStorage.getCourses();
    if (!courses || !courses.length) return;
    this.elements.position.childNodes.forEach((el) => {
      if (!el || !el.dataset) return;
      const isBrainsfirstCard = el.className === "brainsfirst-card"
      const link = el.dataset.link;
      if (!link) return;
      
      const isAllowedCourse = Array.isArray(this.allowedCourses) && this.allowedCourses.includes(link);
      if (!isAllowedCourse && !isBrainsfirstCard) {
        el.classList.add("grey-status")
        const button = el.querySelector("[data-card-button]");
        if (button && button.dataset) {
          button.textContent = button.dataset.checkoutText;
        }
      }
    });
  };

  /** Fetches all courses */
  fetchAllCourses = async () => {
    // Use the shared cache if available
    const Courses = _collow.components.Courses;
    if (Courses.courseCache && Courses.courseCache.allCourses) {
      this.courseGroups = Courses.courseCache.allCourses;
      return;
    }

    // If there's a concurrent fetch in progress, wait for it
    if (Courses.courseCache && Courses.courseCache.isLoading) {
      return new Promise((resolve) => {
        Courses.courseCache.callbacks.push(() => {
          this.courseGroups = Courses.courseCache.allCourses;
          resolve();
        });
      });
    }

    // Otherwise, fetch the data and update the shared cache
    try {
      // Set loading flag if not already set
      if (Courses.courseCache) {
        Courses.courseCache.isLoading = true;
      }

      const res = await fetching(this.params.path + "/course");
      if (Array.isArray(res)) {
        const courseGroups = res.map(course => ({ 
          courseName: course.unique_identifer, 
          groups: [...course.exclusive_groups], 
          registeredUsers: course.registered_users 
        }));
        
        this.courseGroups = courseGroups;
        
        // Update the shared cache if available
        if (Courses.courseCache) {
          Courses.courseCache.allCourses = courseGroups;
          Courses.courseCache.timestamp = Date.now();
          
          // Execute any pending callbacks
          Courses.courseCache.callbacks.forEach(callback => callback());
          Courses.courseCache.callbacks = [];
        }
      }
    } catch (error) {
      console.error("Error fetching all courses:", error);
    } finally {
      // Reset loading flag
      if (Courses.courseCache) {
        Courses.courseCache.isLoading = false;
      }
    }
  }

  /** Fetches allowed courses for current user/user group */
  fetchAllowedCourses = async () => {
    // Use the shared cache if available
    const Courses = _collow.components.Courses;
    
    // Skip if not logged in
    if (!this.userIsLogged) {
      this.allowedCourses = [];
      return;
    }
    
    // Check for cache availability and use it if valid
    const CACHE_TIMEOUT = 5 * 60 * 1000; // 5 minutes
    if (Courses.courseCache && 
        Courses.courseCache.allowedCourses &&
        Courses.courseCache.timestamp && 
        Date.now() - Courses.courseCache.timestamp < CACHE_TIMEOUT) {
      this.allowedCourses = Courses.courseCache.allowedCourses;
      this.setGreyCourses();
      this.setFollowedCourses();
      return;
    }

    // If there's a concurrent fetch in progress, wait for it
    if (Courses.courseCache && Courses.courseCache.isLoading) {
      return new Promise((resolve) => {
        Courses.courseCache.callbacks.push(() => {
          this.allowedCourses = Courses.courseCache.allowedCourses;
          this.setGreyCourses();
          this.setFollowedCourses();
          resolve();
        });
      });
    }

    // Otherwise, fetch the data and update the shared cache
    try {
      // Set loading flag if not already set
      if (Courses.courseCache) {
        Courses.courseCache.isLoading = true;
      }

      const res = await fetching(this.params.path + "/course/allowed_courses");
      if (Array.isArray(res)) {
        const allowedCourses = res.map(course => course.unique_identifer);
        this.allowedCourses = allowedCourses;
        
        // Update the shared cache if available
        if (Courses.courseCache) {
          Courses.courseCache.allowedCourses = allowedCourses;
          Courses.courseCache.timestamp = Date.now();
          
          // Execute any pending callbacks
          Courses.courseCache.callbacks.forEach(callback => callback());
          Courses.courseCache.callbacks = [];
        }
        
        this.setGreyCourses();
        this.setFollowedCourses();
      }
    } catch (error) {
      console.error("Error fetching allowed courses:", error);
      this.allowedCourses = [];
    } finally {
      // Reset loading flag
      if (Courses.courseCache) {
        Courses.courseCache.isLoading = false;
      }
    }
  }
};
